var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0007 3.66699H27.5007C25.0695 3.66699 22.7379 4.63276 21.0188 6.35185C19.2998 8.07093 18.334 10.4025 18.334 12.8337V18.3337H12.834V25.667H18.334V40.3337H25.6673V25.667H31.1673L33.0007 18.3337H25.6673V12.8337C25.6673 12.3474 25.8605 11.8811 26.2043 11.5373C26.5481 11.1935 27.0144 11.0003 27.5007 11.0003H33.0007V3.66699Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d772615fe1f0e16036b77b04804c8f42.svg";
export { ForwardRef as ReactComponent };